import { useEffect } from "react";
import { useSettings } from "@/hooks/useSettings";

function setMeta(attr, key, content) {
  if (content === undefined || content === null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function SEO({ title, description, image, noindex = false, type = "website", jsonLd }) {
  const { settings } = useSettings();
  useEffect(() => {
    const fullTitle = title ? `${title} · ${settings.site_name}` : settings.seo_title || settings.site_name;
    const desc = description || settings.seo_description || "";
    const url = window.location.origin + window.location.pathname;
    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("name", "keywords", settings.seo_keywords || "");
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", title || settings.og_title || fullTitle);
    setMeta("property", "og:description", description || settings.og_description || desc);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", url);
    setMeta("property", "og:site_name", settings.site_name);
    setMeta("property", "og:image", image || settings.og_image || "");
    setMeta("name", "twitter:card", image || settings.og_image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", title || settings.og_title || fullTitle);
    setMeta("name", "twitter:description", description || settings.og_description || desc);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
    if (settings.favicon_url) {
      let icon = document.head.querySelector('link[rel="icon"]');
      if (icon) icon.setAttribute("href", settings.favicon_url);
    }
    let ld = document.getElementById("json-ld");
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "json-ld";
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) ld.remove();
  }, [title, description, image, noindex, type, settings, jsonLd]);
  return null;
}
